import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { fetchAllLoans } from '../utils/loanService';
import Navbar from '../components/Navbar';

const ADMIN_EMAIL = 'admin@lendpesa.web.app';
const fmt = n => `Ksh ${Number(n).toLocaleString()}`;

const STATUS = {
  pending:   { cls:'status-pending',   icon:'⏳' },
  approved:  { cls:'status-approved',  icon:'✅' },
  disbursed: { cls:'status-disbursed', icon:'💰' },
  rejected:  { cls:'status-rejected',  icon:'❌' },
};

export default function AdminDashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    if (!currentUser || currentUser.email !== ADMIN_EMAIL) { navigate('/dashboard'); return; }
    fetchAllLoans().then(data => { setLoans(data); setLoading(false); });
  }, [currentUser, navigate]);

  const filtered = loans.filter(l => {
    const ms = filter==='all' || l.status===filter;
    const mq = !search || [l.userName,l.userPhone,l.reference,l.idNumber].join(' ').toLowerCase().includes(search.toLowerCase());
    return ms && mq;
  });

  const totalAmount = loans.reduce((s,l) => s+Number(l.loanAmount||0), 0);
  const totalFees   = loans.reduce((s,l) => s+Number(l.loanFee||0), 0);
  const pending     = loans.filter(l => l.status==='pending').length;

  if (!currentUser || currentUser.email !== ADMIN_EMAIL) return null;

  return (
    <>
      <Navbar />
      <div className="page-shell">
        <div className="page-inner-wide">
          <div className="page-eyebrow">🔐 Admin Panel</div>
          <h1 className="page-title">Loan Applications</h1>
          <p className="page-sub">Monitor all submitted applications in real-time</p>

          <div className="admin-stat-grid">
            {[
              { icon:'📋', label:'Total Applications', value:loans.length, color:'var(--primary)' },
              { icon:'⏳', label:'Pending',            value:pending,       color:'var(--amber-600)' },
              { icon:'💰', label:'Total Loan Value',   value:fmt(totalAmount), color:'var(--primary)' },
              { icon:'🏦', label:'Fees Collected',     value:fmt(totalFees),   color:'#059669' },
            ].map(s => (
              <div className="admin-stat-card" key={s.label}>
                <div style={{ fontSize:24, marginBottom:8 }}>{s.icon}</div>
                <div style={{ fontFamily:'DM Serif Display, serif', fontSize:22, color:s.color, marginBottom:2, letterSpacing:'-0.2px' }}>{s.value}</div>
                <div style={{ fontSize:12, color:'var(--text-muted)', fontWeight:500 }}>{s.label}</div>
              </div>
            ))}
          </div>

          <div className="filter-bar">
            <input className="filter-input" placeholder="🔍  Search by name, phone, ID or reference…"
              value={search} onChange={e => setSearch(e.target.value)} />
            {['all','pending','approved','disbursed','rejected'].map(s => (
              <button key={s} className={`filter-btn${filter===s?' active':''}`} onClick={() => setFilter(s)}>{s}</button>
            ))}
          </div>

          {loading ? (
            <div style={{ textAlign:'center', padding:'60px 20px' }}>
              <div className="loading-spinner"></div>
              <p style={{ color:'var(--text-muted)', fontSize:14 }}>Loading applications…</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="empty-state"><div className="empty-icon">📭</div><p className="empty-title">No applications found</p></div>
          ) : filtered.map(loan => {
            const s = STATUS[loan.status] || STATUS.pending;
            const date = loan.createdAt ? new Date(loan.createdAt).toLocaleString('en-KE',{dateStyle:'medium',timeStyle:'short'}) : '—';
            return (
              <div className="admin-loan-card" key={loan.id}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:10 }}>
                  <div>
                    <div style={{ fontWeight:600, fontSize:16, color:'var(--text)', marginBottom:3 }}>{loan.userName}</div>
                    <div style={{ fontSize:13, color:'var(--text-muted)' }}>{loan.userEmail} · {loan.userPhone}</div>
                    <div style={{ fontSize:12, color:'var(--text-light)', marginTop:3 }}>ID: {loan.idNumber} · Ref: {loan.reference}</div>
                    <div style={{ fontSize:12, color:'var(--text-light)' }}>Applied: {date} · Type: {loan.loanType}</div>
                  </div>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontFamily:'DM Serif Display, serif', fontSize:22, color:'var(--primary)', marginBottom:6, letterSpacing:'-0.2px' }}>{fmt(loan.loanAmount)}</div>
                    <div style={{ fontSize:13, color:'var(--text-muted)', marginBottom:8 }}>Fee: Ksh {Number(loan.loanFee).toLocaleString()}</div>
                    <span className={`status-badge ${s.cls}`}>{s.icon} <span style={{textTransform:'capitalize'}}>{loan.status}</span></span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
